import {FlowTriggerProps} from "../types/FlowTriggerProps";
import {FlowTypeProps} from "../types/FlowTypeProps";

export const getPossibleMessageTypesByTrigger = (trigger: FlowTriggerProps, flowTypes: FlowTypeProps[]) => {
    const possibleMessageTypes: FlowTypeProps[] = [];
    ['marketing', 'utility', 'recovery', 'chat'].forEach((option: string) => {
        // @ts-ignore
        const filteredFlowType = trigger?.[option] && flowTypes?.find(flowType => flowType.title.toLowerCase() === option);
        filteredFlowType && possibleMessageTypes.push(filteredFlowType);
    });
    return possibleMessageTypes;
}